import styles from '../../index.module.scss';
import type { DirectAllocationChat } from '../useDirectAllocationChat';

// Only ever reached on success — a failed confirm (validation or network)
// stays on the preview card and shows its errors inline there instead of
// navigating to a separate step (see useDirectAllocationChat.confirmImport).
export default function ResultCard({ chat }: { chat: DirectAllocationChat }) {
	const { result } = chat;
	if (!result?.success) return null;
	return <div className={styles['action-card']}>✓ {result.text}</div>;
}
